<template>
  <b-container class="highlight-container">

    <router-link to="/"><i class="fas fa-times btn--close"></i></router-link>

    <b-row>
      <b-col md="12" class="text-center px-0">
        <h1 v-scroll-reveal>Your Choice of <br>Traditional & Contemporary <br>Home Designs </h1>
        <div class="image-wrapper" v-scroll-reveal="{delay: 150}">
          <b-img src="/img/hometypes-highlight-banner.png" fluid center alt="New Seaton New Hometypes" />
        </div>
      </b-col>
    </b-row>

    <b-row class="background--white">
      <b-col md="10" offset-md="1" class="text-center">
        <h3 class="text--red text--extrabold mb-25"><a data-fancybox="video" href="https://player.vimeo.com/video/359775501?title=0&byline=0&portrait=0&transparent=0">WATCH VIDEO</a></h3>
        <p v-scroll-reveal>
          Everyone has their own unique style. The car you drive. The clothes you wear. <br class="d-none d-xl-block">Even
          the way you cut your hair.
          For most of us, finding a home design that perfectly matches our personal style <br class="d-none d-xl-block">has
          long seemed like a dream
          that is just out of reach. But at New Seaton, all your <br class="d-none d-xl-block">home style dreams can
          come true.
        </p>
        <p v-scroll-reveal>All of the three acclaimed builders at New Seaton are pleased to offer both contemporary and
          <br class="d-none d-xl-block">traditional
          home designs. Choose from an incredible selection of designs to find something that's <br class="d-none d-xl-block">perfect
          for your tastes
          and your life here. </p>
        <highlight-footer slot="register" />
      </b-col>
    </b-row>
    
  </b-container>
</template>

<script>
  import highlightFooter from '@/components/HighlightFooter';
  export default {
    components: {
      highlightFooter
    },
    mounted() {
      this.$root.layout.methods.triggerViewPortAnimation()
    },
    transition: {
      mode: 'out-in',
      css: false,
      appear: true,

      enter(el, done) {
        done()
      },
      leave(el, done) {
        done()
      },
    },
  }
</script>

<style scoped>

</style>